import Filter from './Filter.react'

export default Filter